import { FunctionComponent, useState } from 'react'
import { clsx } from 'clsx'
import Image from 'next/image'
import type { Image as ImageType } from '../src/types'
import styles from './ImageBrowser.module.css'

export type Props = {
  images: ImageType[]
}

export const ImageBrowser: FunctionComponent<Props> = ({ images }) => {
  const [current, setCurrent] = useState(images[0])

  return (
    <div className={styles.imageBrowser}>
      <div className="relative">
        <Image src={current.url} alt={current.alt} priority={true} fill />
      </div>

      {images.map((image, index) => (
        <div
          key={index}
          className={clsx('relative', { [styles.current]: image === current })}
        >
          <Image
            priority={image === current}
            src={image.url}
            alt={image.alt}
            onClick={() => setCurrent(image)}
            fill
          />
        </div>
      ))}
    </div>
  )
}
